module.exports = __webpack_public_path__ + "img/E1E1D4_777C7B_9FA19A_898F8D-256px.117c299b.png";